import React, { useEffect, useState, useContext } from 'react'
import defaultMarkerIconPng from "leaflet/dist/images/marker-icon.png";
import SideBarLayout2 from '../layouts/SideBarLayout2'
import Modal from '../components/Modal'
import { useLocation, useNavigate } from 'react-router-dom'
import HomeInput from '../components/formik/HomeInput'
import HomeSubmit from '../components/formik/HomeSubmit'
import * as Yup from 'yup'
import { Formik } from 'formik'
import NavCard from '../components/NavCard'
import { faBackspace, faBackward, faClose, faDiagramProject, faMapLocationDot, faPaperPlane, faProjectDiagram, faStickyNote, faUser, faUserGroup } from '@fortawesome/free-solid-svg-icons'
import IconButton from '../components/IconButton'
import SearchBar from '../components/SearchBar'
import instance from '../api/client'
import authService from '../authentication'
import { toast } from 'react-toastify'
import UserListItem from '../components/UserListItem'
import Loader from '../components/loaders/Loader'
import AppContext from '../contexts/AppContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { MapContainer, TileLayer, Marker } from 'react-leaflet'
import { Icon } from 'leaflet'

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required().label("First name"),
  lastName: Yup.string().required().label("Last name"),
  projectCode: Yup.string().required().label("Project Code"),
  organization: Yup.string().required().label("Organization"),
  email: Yup.string().required().email().label("Email"),
});

export default function CollabList() {
  const location = useLocation();
  const state = location;
  const [loading, setLoading] = useState(false)
  const [collabs, setCollabs] = useState()
  const [searchText, setSearchText] = useState('')
  const [showInviteForm, setShowInviteForm] = useState()
  const navigate = useNavigate();
  const { user, setNavHeaderText } = useContext(AppContext)


  useEffect(() => {
    getCollabs()
  }, [])

  const getCollabs = async () => {
    setLoading(true)
    try {
      const { data, status } = await instance.get(`/projects/all-collaborators/${location?.state?.project?.code}`, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      if (status == 200) {
        console.log(data);
        setCollabs(data)
        setLoading(false)
      } else {
        toast.error(`Error: ${status}`, {
          position: toast.POSITION.TOP_CENTER
        });
      }
    } catch (error) {
      toast.error(`Error: ${error}`, {
        position: toast.POSITION.TOP_CENTER
      });
    }
  }

  const onSubmit = async (form, { resetForm }) => {
    console.log('fsfsfd', form);
    try {
      setLoading(true)
      const { data, status } = await instance.post('/projects/send-invite', form, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      toast.success(`Invite sent`, {
        position: toast.POSITION.TOP_CENTER
      });
      setShowInviteForm(false)
      resetForm();
    } catch (error) {
      toast.error(`Error: ${error}`, {
        position: toast.POSITION.TOP_CENTER
      });
    }
    setLoading(false)
  };

  const searchByName = (searchText, items) => {
    const filteredItems = items?.filter((item) => {
      if (`${item['firstName']?.toLowerCase()} ${item['lastName']?.toLowerCase()}`.search(searchText.toLowerCase()) != -1) {
        return true
      } else {
        return false
      }
    })

    console.log('rite:', filteredItems);
    return filteredItems
  }

  return (
    <SideBarLayout2 title={'Collaborators'}>
      <div className="mx-5 flex-1 flex bg-gray-100 shadow-lg mx-5 px-5 pt-5 rounded">
        <div className='w-2/3 p-10'>
          {!showInviteForm && <SearchBar value={searchText} onChange={(e) => setSearchText(e.target?.value)} />}
          <div className='h-[72.5vh] overflow-y-scroll'>
            <div className='flex w-full justify-end'>
              {
                !showInviteForm ?
                  <IconButton title={'Send Invite'} className={'mb-1 bg-slate-600'} icon={faPaperPlane} onClick={() => { setShowInviteForm(true) }} />
                  :
                  <div onClick={() => setShowInviteForm(false)} className='h-8 w-8 flex cursor-pointer justify-center items-center rounded-lg border-2 border-gray-300 hover:text-white hover:bg-gray-700'>
                    <FontAwesomeIcon icon={faClose} size='1x' />
                  </div>
              }
            </div>
            {
              !loading && !showInviteForm && !collabs?.length && <div className='w-full text-center'>No collaborators</div>
            }
            {!loading ?
              !showInviteForm ?
                searchByName(searchText, collabs)?.map((collab) => (
                  <UserListItem title={`${collab?.firstName} ${collab?.lastName}`} createdAt={'2023-04-05'} updatedAt={'2023-07-09'} />
                ))
                :
                <Formik
                  initialValues={{ email: '', firstName: '', lastName: '', organization: '', projectCode: location?.state?.project.code }}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  <>
                    <div className='mx-16 bg-white px-20 py-8 shadow-lg rounded-lg border-2 border-gray-300'>
                      <div class="my-2 w-full grid grid-cols-2 gap-2">
                        <HomeInput disabled={true} name={'projectCode'} label={"Project Code"} placeholder={'Code'} type={'text'} />
                        <HomeInput name={'email'} label={"email"} placeholder={'colab@rafce.com'} type={'email'} />
                      </div>
                      <div class="my-2 w-full grid grid-cols-2 gap-2">
                        <HomeInput name={'firstName'} label={"first name"} placeholder={'John'} type={'text'} />
                        <HomeInput name={'lastName'} label={"last name"} placeholder={'Doe'} type={'text'} />
                      </div>
                      <div class="my-2 w-full">
                        <HomeInput name={'organization'} label={"organization"} placeholder={'organisation\'s name'} type={'text'} />
                      </div>
                      <div className='mt-10'>
                        <HomeSubmit text={
                          <>
                            <FontAwesomeIcon size='sm' icon={faPaperPlane} />
                            <span className='text-sm ml-5'>SEND INVITE</span>
                          </>
                        } />
                      </div>
                    </div>
                  </>
                </Formik>
              :
              <div style={{}} className='flex items-center justify-center'>
                <div className=' flex-1 items-center bg-white justify-center h-[68vh] pt-20'>
                  <Loader animationName={'list'} width={'100%'} />
                </div>
              </div>

            }

          </div>
        </div>
        <div className='w-1/3  p-5 h-[80vh] overflow-y-scroll'>
          {/* <div className='mt-4'>
            <MapContainer
              style={{
                height: 350,
                width: '100%',
              }}
              // minZoom={3} // just added so you cannot go out of area
              zoom={3}
              center={location?.state?.project.location.coordinates}
            >
              <TileLayer
                url={'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryTopo/MapServer/tile/{z}/{y}/{x}'}
                attribution={'Tiles courtesy of the <a href="https://usgs.gov/">U.S. Geological Survey</a>'}
              />
              <Marker position={location?.state?.project.location.coordinates} icon={new Icon({ iconUrl: defaultMarkerIconPng, iconSize: [25, 41] })}>
              </Marker>
            </MapContainer>
          </div> */}
          <div className='w-full flex gap-2 mt-5'>
            <NavCard className={' bg-red-500 hover:bg-red-600'} onClick={() => { navigate('/project-info/bowties', { state: location.state }) }} icon={faBackward} title={'Back to risk analysis'} />
          </div>
        </div>
      </div>
    </SideBarLayout2>
  )
}
